import { useTranslation } from "@luckymenu/i18n/react";
import { UiLabelsProvider } from "@luckymenu/ui-web";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AiRealtimeProvider } from "../features/ai/realtime";
import { AdminGate } from "../features/gate";
import { MeContext } from "../features/me-context";

function Root() {
	const { t } = useTranslation("common");
	return (
		// The words ui-web's dialogs draw themselves, from the shared i18n.
		<UiLabelsProvider labels={{ close: t("close") }}>
			<AdminGate>
				{(me) => (
					<MeContext value={me}>
						<AiRealtimeProvider>
							<Outlet />
						</AiRealtimeProvider>
					</MeContext>
				)}
			</AdminGate>
		</UiLabelsProvider>
	);
}

export const Route = createRootRoute({ component: Root });
